import { CommentableResource, LexicalText } from "@/schema"

import { useCreateComment, useFetchComments, useToggleReaction } from "@/hooks/api/comments"
import { useFetchCurrentUser } from "@/hooks/api/users"

import { CommentList } from "./comment-list"

interface CommentsProps {
  resourceType: CommentableResource["resourceType"]
  resourceId: string
  className?: string
}

export function Comments({ resourceType, resourceId, className }: CommentsProps) {
  const { data: comments, isLoading, error } = useFetchComments(resourceType, resourceId)
  const { data: currentUser } = useFetchCurrentUser()
  const createComment = useCreateComment()
  const toggleReaction = useToggleReaction()

  const handleCreateComment = async (content: LexicalText, files: File[], parentId?: string) => {
    await createComment.mutateAsync({
      content,
      files,
      parentId,
      commentableType: resourceType,
      commentableId: resourceId,
    })
  }

  const handleReaction = async (commentId: string, emoji: string) => {
    await toggleReaction.mutateAsync({
      commentId,
      emoji,
    })
  }

  return (
    <CommentList
      comments={comments?.comments || []}
      onCreateComment={handleCreateComment}
      onReaction={handleReaction}
      currentUserId={currentUser?.id || ""}
      isLoading={isLoading}
      error={error as Error | null}
      className={className}
    />
  )
}
